module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 342
// module chunks = 0